import React from 'react'

const LinkedInIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#000"
      d="M18.179.4H1.817C1.034.4.4 1.019.4 1.784v16.428c0 .765.634 1.388 1.417 1.388H18.18c.783 0 1.42-.623 1.42-1.384V1.784C19.6 1.019 18.963.4 18.18.4zM6.096 16.761h-2.85V7.596h2.85v9.165zM4.671 6.348a1.65 1.65 0 11-.006-3.302 1.65 1.65 0 01.006 3.302zm12.09 10.413h-2.846v-4.455c0-1.061-.019-2.43-1.481-2.43-1.482 0-1.707 1.159-1.707 2.355v4.53H7.885V7.596h2.73V8.85h.037c.38-.72 1.31-1.481 2.693-1.481 2.884 0 3.416 1.897 3.416 4.364v5.03z"
    ></path>
  </svg>
)

export default LinkedInIcon
